import { useListingContext } from '@/microfrontends/listing/shared/context/ListingContext';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';

import { Breadcrumbs } from './components/Breadcrumbs';

export const BreadcrumbsContainer = memoWithDisplayName(() => {
  const { breadcrumbs } = useListingContext();

  if (!breadcrumbs.length) {
    return null;
  }

  return <Breadcrumbs breadcrumbs={breadcrumbs} />;
}, 'BreadcrumbsContainer');
